<template lang="pug">

  .lesson-block.main-block
    .lesson-block__content
      p.lesson-block__title.main-block__title(v-if="content.header") {{content.header}}

      .lesson-block__markdown.form-item__markdown(
        v-if="content.text"
        v-html="makeHtml(content.text)"
      )
    slot
</template>

<script>
import MarkdownText from '@/components/Form/MarkdownText';
import markdownToHtml from '@/functions/converterMarkdownToHtml';

export default {
  components: { MarkdownText },
  props: {
    content: {}
  },
  methods: {
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    }
  }
};
</script>
